import Front from '../components/Front';
import Experiences from '../components/Experiences';
import Popular from '../components/Popular';
import Video from '../components/Video';
import Slider from '../components/Slider';
import Views from '../components/Views';
import Cover from '../components/cover';

const HomePage = () => {
    return ( 
        <>
            
            <Front />
            
            <Popular />
            <Experiences />
            <Video />
           
            
            <Cover />
            <Slider />
            <Views />

        </>
    );
}

export default HomePage;
